module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container full-width"
  }, [_vm._m(0), _vm._v(" "), _c('app-header'), _vm._v(" "), _c('side-info', {
    ref: "sideInfo",
    style: ([_vm.mainPaddingTop]),
    attrs: {
      "template": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: (_vm.mainPaddingTop)
  }, [_c('div', {
    staticClass: "fil-ariane"
  }, [_c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/home"
    }
  }, [_vm._v("\n          Mon espace >\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/creer-un-message"
    }
  }, [_vm._v("\n          Ajouter un nouveau message >\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/gerer-diffusion"
    }
  }, [_vm._v("\n          Gérer ma diffusion\n        ")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Créer mon message")]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "info-box-main",
    staticStyle: {
      "margin-top": "calc(85vh / (949 / 21))"
    }
  }, [_c('svg', {
    staticClass: "info-box-icon-main",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8949 -947 14.89 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z",
      "transform": "translate(8926.444 -1944.365)"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "editor-holder col-md-12 col-lg-12"
  }, [_vm._l((_vm.templates), function(template, index) {
    return _c('div', {
      staticClass: "vignette-holder"
    }, [_c('img', {
      staticClass: "vignette",
      attrs: {
        "src": template.thumbnail,
        "data-template-index": template.id
      },
      on: {
        "click": function($event) {
          return _vm.pickTemplate(template.name)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "template-label"
    }, [_vm._v(_vm._s(template.label))])])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "visualisation-holder-reduced"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "explication-texte"
  }, [_vm._v("*Afin de modifier le style de votre texte, selectionner le texte en double cliquant dessus")])], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 15))"
    },
    attrs: {
      "id": "set-message-compo"
    }
  }, [_vm._v("\n        VALIDER\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  })])]), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "modalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#errModal"
    }
  }, [_vm._v("\n    Launch modal\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "errModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "arrow",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2-arrow",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("\n                VOTRE MESSAGE COMPORTE"), _c('br'), _vm._v("LES ERREURS SUIVANTES :\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "error-modal-content"
    }
  }, [_c('ul')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-text-main"
  }, [_vm._v("\n          Créez une nouvelle communication en choisissant un modèle,"), _c('br'), _vm._v("un titre et un texte pour votre annonce.\n        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c81593f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c81593f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreerUnMessage.vue
// module id = 202
// module chunks = 1